import React from "react";
import { ShoppingBag, PackageOpen, Users, TrendingUp } from "lucide-react";
import { SectionHeading } from "@/components/PackSelection";

const steps = [
  { icon: ShoppingBag, title: "Choisissez votre pack", text: "Sélectionnez le pack correspondant à votre budget et à votre projet." },
  { icon: PackageOpen, title: "Recevez vos produits", text: "Découvrez votre sélection de produits Ozentya." },
  { icon: Users, title: "Présentez & vendez", text: "Faites découvrir les produits à votre entourage et développez progressivement votre clientèle." },
  { icon: TrendingUp, title: "Développez vos ventes", text: "Organisez votre activité selon vos disponibilités et vos objectifs." },
];

export const HowItWorks = () => (
  <section id="how" className="bg-[var(--oz-bg-2)] scroll-mt-20">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 md:py-24">
      <SectionHeading eyebrow="Comment ça marche" title="Votre activité en 4 étapes" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map((s, i) => (
          <div
            key={i}
            data-testid={`how-step-${i}`}
            className="relative bg-white rounded-2xl p-7 border border-[var(--oz-border)] hover:border-[var(--oz-gold)] transition-colors group"
          >
            <span className="font-serif text-5xl text-[var(--oz-nude)] absolute top-4 right-5 group-hover:text-[var(--oz-gold)]/30 transition-colors">
              0{i + 1}
            </span>
            <div className="w-12 h-12 rounded-xl bg-[var(--oz-nude)] flex items-center justify-center text-[var(--oz-badge)] mb-5">
              <s.icon className="w-6 h-6" />
            </div>
            <h3 className="font-serif text-xl text-[var(--oz-text)] mb-2">{s.title}</h3>
            <p className="text-sm text-[var(--oz-muted)] leading-relaxed">{s.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
